import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TYPES'

const EN_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS: T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Trail Period',
    DESCRIPTION:
      'Your trial period ends on {subscriptionExpireOn}. Please contact an adult to extend your subscription.',
    CTA_TEXT: 'Close'
  }

export default EN_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS
